// extracted by mini-css-extract-plugin
module.exports = {"page-container":"page-container_1E3B","footer-outer_wrap":"footer-outer_wrap_32xt","center":"center_2yxI"};